import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint";

export default {
    getKodeAkunSettlement: () => {
        return conn.get(api.getKodeAkunSettlement);
    },
    getIdAkun: ({ commit, dispatch }, loadOutlet = true) => {
        conn.get(api.getIdAkun)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200) {
                    if (status) {
                        commit("setIdAkunEdc", data.idakun_mesin_edc);
                    } else {
                        commit("setResponse", resulter.errorResult(msg));
                    }

                    if (loadOutlet) {
                        dispatch("getListOutlet");
                    }
                }
            })
            .catch((e) => {
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getListOutlet: ({ commit, dispatch }, loadProvider = true) => {
        conn.get(api.getListOutlet)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200) {
                    if (status) {
                        commit("setListOutlet", data);
                    } else {
                        commit("setResponse", resulter.errorResult(msg));
                    }

                    if (loadProvider) {
                        dispatch("getListProvider");
                    }
                }
            })
            .catch((e) => {
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getListProvider: ({ commit, dispatch }, loadSettlement = true) => {
        conn.get(api.getListProvider)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200) {
                    if (status) {
                        commit("setListProvider", data);
                    } else {
                        commit("setResponse", resulter.errorResult(msg));
                    }

                    if (loadSettlement) {
                        dispatch("getListSettlement");
                    }
                }
            })
            .catch((e) => {
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getListSettlement: ({ commit }) => {
        conn.get(api.getListSettlement)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200) {
                    if (status) {
                        commit("setListSettlement", data);
                        commit("setResponse", resulter.successResult(msg));
                    } else {
                        commit("setResponse", resulter.errorResult(msg));
                    }
                }
            })
            .catch((e) => {
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getQueryStringIndex: ({ rootGetters, getters }, { key }) => {
        let getFilter = rootGetters["filterGlobalModule/getFilter"];
        let getFilterItem = rootGetters["filterGlobalModule/getFilterItem"];

        let query = {
            key,
            sort_by: getFilter.sortBy,
            order_by: getFilter.orderBy,
            limit: getters.pagination.limit,
            offset: getters.pagination.offset,
        };

        Object.keys(getFilterItem).forEach((key) => {
            if (getFilterItem[key].length > 0) {
                switch (key) {
                    case "akunSettlement":
                        query.idakun_settlement = getFilterItem[key];
                        break;
                    case "providerEdc":
                        query.idprovider = getFilterItem[key];
                        break;
                    case "outlet":
                        query.idoutlet = getFilterItem[key];
                        break;
                    case "statusMesinEdc":
                        query.status_aktif = getFilterItem[key];
                        break;
                }
            }

            if (key === "periode") {
                query.filter_by = getFilterItem[key].filterBy;
                if (getFilterItem[key].filterBy === "periode") {
                    query.tanggal_awal = getFilterItem[key].startDate;
                    query.tanggal_akhir = getFilterItem[key].endDate;
                }

                if (getFilterItem[key].filterBy === "tahun") {
                    query.tahun = getFilterItem[key].year;
                }
                if (getFilterItem[key].filterBy === "bulan") {
                    query.bulan = getFilterItem[key].month;
                }
            }
        });

        return query;
    },
    getDataMesin: ({ commit, dispatch }, payload) => {
        dispatch("getQueryStringIndex", payload)
            .then((query) => {
                commit("setFetching", true);
                conn.get(api.getDataMesin, query).then((res) => {
                    let { code, data, status, msg } = res.data;
                    if (code === 200) {
                        if (status) {
                            let dataMesin = {
                                data: data.rincian_data_mesin_edc,
                                total: data.total_mesin_edc,
                                saldo: data.total_saldo,
                                tglAwal: data.periode_awal_formated,
                                tglAkhir: data.perioder_akhir_formated,
                            };
                            commit("setDataMesin", dataMesin);
                            commit("setResponse", resulter.successResult(msg));
                        } else {
                            commit("setResponse", resulter.errorResult(msg));
                        }

                        dispatch("getListMesin", payload);
                    }
                });
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getListMesin: ({ commit, dispatch }, payload) => {
        dispatch("getQueryStringIndex", payload)
            .then((query) => {
                commit("setFetching", true);
                conn.get(api.getListMesin, query).then((res) => {
                    let { code, data, status, msg } = res.data;
                    if (code === 200) {
                        conn.setQueryString(query);
                        if (status) {
                            commit("setListMesin", data);
                            commit("setResponse", resulter.successResult(msg));
                            commit("setEndItemOfPage", data[data.length - 1]);
                            commit("setNextPagination", data);
                        } else {
                            commit("setResponse", resulter.errorResult(msg));
                        }
                    }
                    commit("setFetching", false);
                    commit("setLoadMore", false);
                });
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setLoadMore", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    getListMesinAll: ({ commit }, payload) => {
        commit("setFetching", true);
        conn.get(api.getListMesinAll).then((res) => {
            let { code, data, status, msg } = res.data;
            if (code === 200) {
                if (status) {
                    commit("setListMesinAll", data);
                    commit("setResponse", resulter.successResult(msg));
                } else {
                    commit("setResponse", resulter.errorResult(msg));
                }
            }
            commit("setFetching", false);
            commit("setLoadMore", false);
        });
    },
    getDetailMesin: ({ commit }, payload) => {
        let query = {
            idedc: payload,
        };
        commit("setFetching", true);
        conn.get(api.getDetailMesin, query)
            .then((res) => {
                let { code, data, status, msg } = res.data;
                if (code === 200) {
                    if (status) {
                        commit("setDetailMesin", data);
                        commit("setResponse", resulter.successResult(msg));
                    } else {
                        commit("setResponse", resulter.errorResult(msg));
                    }
                }
                commit("setFetching", false);
            })
            .catch((e) => {
                commit("setFetching", false);
                commit("setResponse", resulter.errorResult(e));
            });
    },
    createKodeAkun: (state, payload) => {
        let posted = new FormData();
        Object.keys(payload).forEach(function(key) {
            posted.append(key, payload[key]);
        });
        return conn.post(api.createKodeAkun, posted, conn.contentType.form);
    },
    saveMesinEdc: ({ commit }, payload) => {
        let posted = new FormData();

        Object.keys(payload).forEach(function(key) {
            if (key !== "idedc") {
                posted.append(key, payload[key]);
            }
        });

        let callApi = payload.idedc ? `${api.updateMesin}?idedc=${payload.idedc}` : api.createMesin;

        commit("setFetching", true);
        return conn.post(callApi, posted, conn.contentType.form);
    },
    deleteMesinEdc: ({ commit }, payload) => {
        let callApi = `${api.deleteMesin}?idedc=${payload}`;

        commit("setFetching", true);
        return conn.post(callApi, null, conn.contentType.form);
    },
    async exportTracker({ commit }) {
      try {
          let keyExport = localStorage.getItem("key_export_edc");
          if (keyExport === null) {
              return resulter.errorResult();
          }
          let query = {
              key: keyExport,
          };

          const tracker = await conn.get(api.export.track, query);

          if (!tracker.data) {
              throw tracker;
          }

          if (tracker.data.status) {
            return resulter.successResult(tracker.data.msg, tracker.data.data);
          } else {
            return resulter.errorResult(tracker.data.msg, tracker.data.data);
          }
      } catch (e) {
          return resulter.errorResult(e);
      }
  },
  async exportDeleteMaster({commit}) {
      try {
          let keyExport = localStorage.getItem("key_export_edc");
          let query = {
              key: keyExport,
          };
          const res = await conn.get(api.export.delete.master, query);
          if (!res.data) {
              throw res;
          }
          if (res.data.code === 200) {
              localStorage.removeItem("key_export_edc");
              return resulter.successResult(res.data.msg, res.data.data);
          } else {
              return resulter.errorResult(res.data.msg, res.data.data);
          }
      } catch (e) {
          return resulter.errorResult(e);
      }
  },
  async exportDeleteCluster({ commit }, key) {
      try {
          let query = {
              key,
          };
          const res = await conn.get(api.export.delete.cluster, query);
          if (!res.data) {
              throw res;
          }

          if (res.data.code === 200) {
            return resulter.successResult(res.data.msg, res.data.data);
          } else {
            return resulter.errorResult(res.data.msg, res.data.data);
          }
      } catch (e) {
          return resulter.errorResult(e);
      }
  },
};
